module.exports = __webpack_public_path__ + "static/label-hand-b5d242c74d4a8acd8f40c32ae108600c.png";